import { render, staticRenderFns } from "./BlockVideoViewer.vue?vue&type=template&id=42ee23b8"
import script from "./BlockVideoViewer.vue?vue&type=script&lang=js"
export * from "./BlockVideoViewer.vue?vue&type=script&lang=js"
import style0 from "./BlockVideoViewer.vue?vue&type=style&index=0&id=42ee23b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports